import { render } from "./DeviceCo2Setting.vue?vue&type=template&id=2055800e"
import script from "./DeviceCo2Setting.vue?vue&type=script&lang=js"
export * from "./DeviceCo2Setting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__